module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNC43MyAyNy40NiI+PGRlZnM+PHN0eWxlPi5jbHMtMXtmaWxsOm5vbmU7c3Ryb2tlOiNFMDQ0MDM7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLW1pdGVybGltaXQ6MTA7c3Ryb2tlLXdpZHRoOjJweDt9PC9zdHlsZT48L2RlZnM+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik0xMy43MywxMy43MywxLDI2LjQ2Ii8+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMTMuNzMsMTMuNzMsMSwxIi8+PC9nPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brands/generic/arrow_right_orange_pr.svg
// module id = 4B4w
// module chunks = 12